module.exports = __webpack_public_path__ + "static/media/ServiceTask.d25b4537.svg";